import { render } from "./FilingApproach.vue?vue&type=template&id=fd6f2aa4&scoped=true"
import script from "./FilingApproach.vue?vue&type=script&lang=js"
export * from "./FilingApproach.vue?vue&type=script&lang=js"

import "./FilingApproach.vue?vue&type=style&index=0&id=fd6f2aa4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd6f2aa4"]])

export default __exports__